<template>
    <transition
        appear
        name="fade"
    >
        <div
            v-if="imagesLoaded"
            ref="wrapper"
            class="guide-wrapper"
        >
            <SpeechBubble
                ref="bubble"
                class="round"
                speech-tail="right"
            >
                <span v-html="text" />
            </SpeechBubble>
            <img
                class="guide-image"
                :src="guideImage"
            >
        </div>
    </transition>
</template>

<script>
import AudioController from '@kids/lib/class/AudioController';
import ImageLoader from '@kids/lib/class/ImageLoader';

const imageLoader = new ImageLoader([
    {
        id: 'pose1',
        src: require('@/assets/guide/avatar-1.png')
    },
    {
        id: 'pose2',
        src: require('@/assets/guide/avatar-2.png')
    },
    {
        id: 'pose3',
        src: require('@/assets/guide/avatar-3.png')
    },
    {
        id: 'pose4',
        src: require('@/assets/guide/avatar-4.png')
    }
]);

const {setTimeout, clearTimeout} = globalThis;

export default {
    name: 'Guide',
    props: {
        slides: {
            type: Array,
            required: true
        },
        autoplay: {
            type: Boolean,
            default: true
        },
        delay: {
            type: Number,
            default: 2
        }
    },
    data: () => (
        {
            imagesLoaded: false,
            slideIndex: 0
        }),
    computed: {
        currentSlide()
        {
            return this.slides[this.slideIndex];
        },
        guideImage()
        {
            return imageLoader.get(`pose${this.currentSlide.pose}`).src;
        },
        text()
        {
            return this.currentSlide.text;
        }
    },
    created()
    {
        imageLoader.loaded.then(() =>
        {
            this.imagesLoaded = true;
        });
    },
    mounted()
    {
        const audioManifest = [];
        this.slides.forEach((slide, index) =>
        {
            if (!slide.audio) { return; }
            audioManifest.push({
                id: `audio${index}`,
                path: slide.audio.replace(/\.mp3$/, '')
            });
        });

        this._audioController = new AudioController();
        this._audioController.loadManifest(audioManifest);

        if (!this.autoplay) { return; }

        this._delayTimeout = setTimeout(
            () => this._audioController.loaded.then(this.showSpeechBubble),
            this.delay * 1000
        );
    },
    destroyed()
    {
        if (this._audioController)
        {
            this._audioController.destroy();
        }

        if (this._delayTimeout)
        {
            clearTimeout(this._delayTimeout);
        }
    },
    methods: {
        showSpeechBubble()
        {
            this.$refs.bubble.show(() =>
            {
                this.playSound();
            });
        },
        showNextSlide()
        {
            if (this.slideIndex >= this.slides.length - 1)
            {
                this.$emit('complete');
                return;
            }

            this.slideIndex += 1;
            this.showSpeechBubble();
        },
        playSound()
        {
            if (!this.currentSlide.audio) { return; }

            this._audioController
                .play(`audio${this.slideIndex}`, {eventable: true})
                .on('end', () =>
                {
                    this.$refs.bubble.hide(() =>
                    {
                        this.hideSpeechBubble();
                    });
                });
        },
        hideSpeechBubble()
        {
            this.$emit('slideFinished');

            if (!this.autoplay) { return; }
            this.showNextSlide();
        }
    }
};
</script>

<style lang="scss" src="./Guide.scss" />

